import {
    getBorder,
    getCssClasses,
    getImageQuality,
    getIsHidden,
    getMargin,
    getPadding,
    getTextAlign
} from '../../utils'

const configAggregator = (node) => {
    const images = Array.from(node.querySelectorAll('img'))
    const sources = Array.from(node.querySelectorAll('source'))
    const anchor = node.querySelector('a')

    if (images.length === 0) {
        return {}
    }

    const props = {
        desktopImage: images[0] ? images[0].getAttribute('src') : null,
        mobileImage: sources[0]
            ? sources[0].getAttribute('srcset')
            : images[1]
              ? images[1].getAttribute('src')
              : null,
        altText: images[0] ? images[0].getAttribute('alt') : null,
        title: images[0] ? images[0].getAttribute('title') : null,
        imgWidth: images[0] ? images[0].getAttribute('width') : null,
        imgWidthMob: images[1] ? images[1].getAttribute('width') : null,
        imgHeight: images[0] ? images[0].getAttribute('height') : null,
        imgHeightMob: images[1] ? images[1].getAttribute('height') : null,
        imageQuality: getImageQuality(getCssClasses(node).cssClasses),
        ...getPadding(node),
        ...getMargin(node),
        ...(images[0] ? getBorder(images[0]) : {}),
        ...getCssClasses(node),
        ...getTextAlign(node),
        ...getIsHidden(node)
    }

    if (props.desktopImage === props.mobileImage) {
        props.mobileImage = null
    }

    if (anchor) {
        props.link = anchor.getAttribute('href')
        props.linkType = anchor.getAttribute('data-link-type')
        props.openInNewTab = anchor.getAttribute('target') === '_blank'
    }

    const captionElement = node.querySelector('figcaption')
    if (captionElement) {
        props.caption = captionElement.textContent
    }
    return props
}

export default configAggregator
